import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { jobService, IncompleteJob } from '@/src/services/http/jobService'

interface IncompleteJobsState {
  incompleteJobs: {
    data: IncompleteJob[]
    loading: boolean
    error: string | null
    count: number
    currentPage: number
    pageSize: number
  }
}

const initialState: IncompleteJobsState = {
  incompleteJobs: {
    data: [],
    loading: false,
    error: null,
    count: 0,
    currentPage: 0,
    pageSize: 10
  }
}

// Async thunk for fetching incomplete jobs
export const fetchIncompleteJobs = createAsyncThunk('incompleteJobs/fetchIncompleteJobs', async (params?: any) => {
  const response = await jobService.getIncompleteJobs(params)

  return response
})

// Async thunk for marking a specific job as failed
export const markJobAsFailed = createAsyncThunk('incompleteJobs/markJobAsFailed', async (jobId: number) => {
  const response = await jobService.markJobAsFailed(jobId)

  return response
})

const incompleteJobsSlice = createSlice({
  name: 'incompleteJobs',
  initialState,
  reducers: {
    clearError: state => {
      state.incompleteJobs.error = null
    }
  },
  extraReducers: builder => {
    builder

      // Fetch incomplete jobs
      .addCase(fetchIncompleteJobs.pending, state => {
        state.incompleteJobs.loading = true
        state.incompleteJobs.error = null
      })
      .addCase(fetchIncompleteJobs.fulfilled, (state, action) => {
        state.incompleteJobs.loading = false
        state.incompleteJobs.data = action.payload.data || []
        state.incompleteJobs.count = action.payload.meta?.total || action.payload.count || 0
        state.incompleteJobs.currentPage = action.payload.meta?.page ? parseInt(action.payload.meta.page) : 0
        state.incompleteJobs.pageSize = action.payload.meta?.pageSize ? parseInt(action.payload.meta.pageSize) : 10
        state.incompleteJobs.error = action.payload.error
      })
      .addCase(fetchIncompleteJobs.rejected, (state, action) => {
        state.incompleteJobs.loading = false
        state.incompleteJobs.error = action.error.message || 'Failed to fetch incomplete jobs'
      })

      // Mark job as failed
      .addCase(markJobAsFailed.pending, state => {
        state.incompleteJobs.loading = true
      })
      .addCase(markJobAsFailed.fulfilled, state => {
        state.incompleteJobs.loading = false
      })
      .addCase(markJobAsFailed.rejected, (state, action) => {
        state.incompleteJobs.loading = false
        state.incompleteJobs.error = action.error.message || 'Failed to mark job as failed'
      })
  }
})

export const { clearError } = incompleteJobsSlice.actions
export default incompleteJobsSlice.reducer
